<template>
  <ul class="control-list">
    <li
      v-for="(control, key) in controlsList"
      @click="$emit('onClick', control.property)"
      :class="`control-list__item ${isActive(control)}`"
      :key="key"
    >
      <button class="control-list__button">{{control.title}}</button>
    </li>
  </ul>
</template>

<script>
export default {
  name: "dynamicControls",
  props: {
    controlsList: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isActive(control) {
      return control.active ? "control-list__button--active" : "";
    },
  },
};
</script>

<style>
.control-list {
  display: flex;
  justify-content: flex-end;
  padding: 0;
  margin: 0 0 10px 0;
  list-style: none;
}

.control-list__item {
  margin-right: 10px;
}

.control-list__item:last-child {
  margin-right: 0;
}

.control-list__button {
  font-family: "Oswald", "Arial", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: normal;
  border: none;
  outline: none;
  cursor: pointer;
}

.control-list__button:hover {
  color: #ffffff;
  background-color: #0084ff;
}

.control-list__button--active .control-list__button{
  color: #ffffff;
  background-color: #0084ff;
}
</style>
